
import React from 'react';

interface ResearchCardContentProps {
  title: string;
  contentSnippet: string;
}

const ResearchCardContent: React.FC<ResearchCardContentProps> = ({
  title,
  contentSnippet,
}) => {
  return (
    <>
      {/* Title */}
      <h3 className="font-semibold text-lg text-foreground mb-2 md:mb-3 leading-tight group-hover:text-purple-600 dark:group-hover:text-purple-400 transition-colors duration-300">
        {title}
      </h3>
      
      {/* Content snippet */}
      <p className="text-sm text-muted-foreground mb-3 md:mb-4 leading-relaxed line-clamp-3 font-medium">
        {contentSnippet}
      </p>
    </>
  );
};

export default ResearchCardContent;
